"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var List = function (_a) {
    var _b = _a.elements, elements = _b === void 0 ? [] : _b;
    return (react_1.default.createElement("ul", null, elements.map(function (el, i) {
        return (react_1.default.createElement("li", { key: el && el.props && el.props.key ? el.props.key : i }, el));
    })));
};
exports.List = List;
